import React, { useContext } from 'react';
import InputField from '../../components/InputField';
import SelectItem from '../../components/SelectItem';
import './../../../styles/irctcCreateAccountForms.css';
import { checkValidation, validations } from '../../../utils/FormValidators';
import axios from 'axios';
import { CREATE_ACCOUNT_FORM_ELEMENT_ID, SERVER_URL } from '../../../utils/RailsSEOConstants';
import { IrctcCreateAccountContext } from '../IrctcCreateAccountPage';
import * as irctcCreateAccountActions from './../../../actions/irctcCreateAccountActions';
import PropTypes from 'prop-types';
import { isMobile } from '../../../utils/commonUtils';

const AddressInfoForm = (props) => {
  const isMobileDevice = isMobile();
  const { customClass } = props;
  const context = useContext(IrctcCreateAccountContext);
  const {
    createAccountState: {
      showErrorCreateAccount,
      residentialAddress,
      alternateContact,
      selectedCountry,
      pinCode,
      pinCodeErrorMessage,
      cityList,
      stateList,
      postOfficeList,
      officePostOffice,
      officeCity,
      officeRegionalState,
      countryList
    },
    createAccountDispatch
  } = context;
  const updateResidentialAddress = (latestResidentialAddress) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_RESIDENTIAL_ADDRESS_CREATE_ACCOUNT,
      data: latestResidentialAddress
    });
  };
  const updateAlternateContact = (latestAlternateContact) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_ALTERNATE_CONTACT_CREATE_ACCOUNT,
      data: latestAlternateContact
    });
  };
  const updateSelectedCountry = (latestCountry) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_SELECTED_COUNTRY_CREATE_ACCOUNT,
      data: latestCountry
    });
  };
  const updateCityList = (latestCityList) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_CITY_LIST_CREATE_ACCOUNT,
      data: latestCityList
    });
  };
  const updateStateList = (latestStateList) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_STATE_LIST_CREATE_ACCOUNT,
      data: latestStateList
    });
  };
  const updatePostOfficeList = (latestPostOfficeList) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_POST_OFFICE_LIST_CREATE_ACCOUNT,
      data: latestPostOfficeList
    });
  };
  const updateOfficePostOffice = (latestOfficePostOffice) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_OFFICE_POST_OFFICE_CREATE_ACCOUNT,
      data: latestOfficePostOffice
    });
  };
  const updateOfficeCity = (latestOfficeCity) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_OFFICE_CITY_CREATE_ACCOUNT,
      data: latestOfficeCity
    });
  };
  const updateOfficeRegionalState = (latestOfficeRegionalState) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_OFFICE_REGIONAL_STATE_CREATE_ACCOUNT,
      data: latestOfficeRegionalState
    });
  };
  const updatePinCodeErrorMessage = (latestPinCodeErrorMessage) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_PINCODE_ERR_MSG_CREATE_ACCOUNT,
      data: latestPinCodeErrorMessage
    });
  };

  const getDetailsFromPinCode = async (officePinCode) => {
    try {
      if (checkValidation(officePinCode, validations.officePinCode)) {
        const body = { pinCode: officePinCode };
        const res = await axios.post(`${SERVER_URL}/pinCode`, body);
        if (res && res.data && !res.data.errorDetails) {
          const officeCityList = [res.data.city];
          const officePostOfficeList = res.data.postOfficeList;
          const officeStateList = [res.data.state];
          updateCityList(officeCityList);
          updateOfficeCity(null);
          updateStateList(officeStateList);
          updateOfficeRegionalState(null);
          updatePostOfficeList(officePostOfficeList);
          updateOfficePostOffice(null);
          updatePinCodeErrorMessage('');
        } else if (res && res.data && res.data.errorDetails) {
          updatePinCodeErrorMessage(res.data.errorDetails.errorMessage);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  const updatePinCode = (latestPinCode) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_PINCODE_CREATE_ACCOUNT,
      data: latestPinCode
    });
    getDetailsFromPinCode(latestPinCode);
  };

  const validateAddress = () => {
    return residentialAddress && residentialAddress.length >= 3 && residentialAddress.length <= 225;
  };

  return (
    <div className={`${customClass} irctcDetailsComp__add`}>
      <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.residentialAddress} />
      <InputField
        label="Enter your residential address"
        placeholder="Enter your residential address"
        customClass="appendBottom30"
        value={residentialAddress}
        updateParentValue={updateResidentialAddress}
        errorMsg={'Enter a valid address between 3 to 225 characters'}
        error={showErrorCreateAccount && !validateAddress()}
      />
      <div className={`makeFlex ${isMobileDevice ? 'column appendBottom30' : 'appendBottom40'}`}>
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.alternateContact} />
        {!isMobileDevice && (
          <InputField
            label="Alternate contact number"
            mobNum="true"
            placeholder="Mobile Number"
            customClass="appendRight30"
            maxLength={10}
            value={alternateContact}
            updateParentValue={updateAlternateContact}
            errorMsg={'Enter a valid mobile number'}
            error={showErrorCreateAccount && !checkValidation(alternateContact, validations.mobileNumber)}
          />
        )}
        {isMobileDevice && (
          <InputField
            label="Alternate contact number"
            mobNum="true"
            placeholder="Mobile Number"
            customClass="appendBottom30"
            maxLength={10}
            value={alternateContact}
            updateParentValue={updateAlternateContact}
            errorMsg={'Enter a valid mobile number'}
            error={showErrorCreateAccount && !checkValidation(alternateContact, validations.mobileNumber)}
          />
        )}
        <div className={`makeFlex column ${isMobileDevice ? 'appendBottom30' : 'appendBottom40'}`}>
          <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.selectedCountry} />
          <SelectItem
            selectOption={countryList}
            labelText="Select your country of Residence"
            customClass="halfWidth"
            selectedIndex={selectedCountry}
            updateParentIndex={updateSelectedCountry}
          />
          <p className="appendTop5 font12">Foreign nationals can register through IRCTC website only</p>
        </div>
      </div>

      <div className={`makeFlex ${isMobileDevice ? 'column appendBottom30' : 'appendBottom40'}`}>
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.pinCode} />
        {!isMobileDevice && (
          <InputField
            label="Enter your Pincode"
            placeholder="Enter your Pincode"
            maxLength={6}
            customClass="appendRight30"
            value={pinCode}
            updateParentValue={updatePinCode}
            errorMsg={pinCodeErrorMessage || 'Enter a valid pin code'}
            error={!!pinCodeErrorMessage || (showErrorCreateAccount && !checkValidation(pinCode, validations.pinCode))}
          />
        )}
        {isMobileDevice && (
          <InputField
            label="Enter your Pincode"
            placeholder="Enter your Pincode"
            maxLength={6}
            value={pinCode}
            customClass="appendBottom30"
            updateParentValue={updatePinCode}
            errorMsg={pinCodeErrorMessage || 'Enter a valid pin code'}
            error={!!pinCodeErrorMessage || (showErrorCreateAccount && !checkValidation(pinCode, validations.pinCode))}
          />
        )}
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.officeCity} />
        {cityList && (
          <SelectItem
            selectOption={cityList}
            labelText="Select your city"
            customClass="halfWidth"
            selectedIndex={officeCity}
            updateParentIndex={updateOfficeCity}
          />
        )}
      </div>

      {stateList && (
        <div className={`makeFlex ${isMobileDevice ? 'column appendBottom30' : 'appendBottom40'}`}>
          <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.officePostOffice} />
          {postOfficeList && (
            <SelectItem
              selectOption={postOfficeList}
              labelText="Select your postOffice"
              customClass={`halfWidth ${isMobileDevice ? 'appendBottom30' : 'appendRight30'}`}
              selectedIndex={officePostOffice}
              updateParentIndex={updateOfficePostOffice}
            />
          )}
          <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.officeRegionalState} />
          {stateList && (
            <SelectItem
              selectOption={stateList}
              labelText="Select your state"
              customClass="halfWidth"
              selectedIndex={officeRegionalState}
              updateParentIndex={updateOfficeRegionalState}
            />
          )}
        </div>
      )}
    </div>
  );
};

AddressInfoForm.propTypes = {
  customClass: PropTypes.string
};
export default AddressInfoForm;
